import Background from './Background'
import Elements from './Elements'
import Text from './Text'
import Templates from './Templates'
import Delete from './Delete'
import Locked from './Locked'
import UnLocked from './Unlocked'
import Bold from './Bold'
import Italic from './Italic'
import TextColor from './TextColor'
import FillColor from './FillColor'
import Images from './Images'
import TextAlignCenter from './TextAlignCenter'
import TextAlignRight from './TextAlignRight'
import TextAlignLeft from './TextAlignLeft'
import TextAlignJustify from './TextAlignJustify'
import Underline from './Underline'
import Opacity from './Opacity.'
import Duplicate from './Duplicate'
import ToFront from './ToFront'
import Forward from './Forward'
import ToBack from './ToBack'
import Backward from './Backward'
import Undo from './Undo'
import Redo from './Redo'
import ChevronLeft from './ChevronLeft'
import Spacing from './Spacing'
import CopyStyle from './CopyStyle'

class Icons {
  static Background = Background
  static Elements = Elements
  static Text = Text
  static Templates = Templates
  static Delete = Delete
  static Locked = Locked
  static UnLocked = UnLocked
  static Bold = Bold
  static Italic = Italic
  static TextColor = TextColor
  static FillColor = FillColor
  static Images = Images
  static TextAlignRight = TextAlignRight
  static TextAlignCenter = TextAlignCenter
  static TextAlignLeft = TextAlignLeft
  static TextAlignJustify = TextAlignJustify
  static Underline = Underline
  static Opacity = Opacity
  static Duplicate = Duplicate
  static ToFront = ToFront
  static Forward = Forward
  static ToBack = ToBack
  static Backward = Backward
  static Undo = Undo
  static Redo = Redo
  static ChevronLeft = ChevronLeft
  static Spacing = Spacing
  static CopyStyle = CopyStyle
}

export default Icons
